/**
 * Splits a contact number into phone number and extension parts.
 *
 * @param {QuestionResponse} item - the question to investigate to see if answered. '.
 * @returns {boolean} indication of whether or not question is answered.
 */
export const isAnswered = (item) => {
    let answered = [];

    switch(item.questionType) {
        case "checkbox":
            answered = item.answer.filter(option => option.answer == true);
            break;
        case "freeText":
            answered = item.answer.filter(option => {
                return (option.answer.toString().trim().length > 0 && option.answer !== "<p><br></p>")
            });
            break;
        case "singleFreeText":
        case "dropDown":
            answered = item.answer.filter(option => {
                return option.answer.toString().trim().length > 0
            });
            break;
        case "radio":
            answered = item.answer.filter(option => option.answer == true);
            break;
        default:
                break;
    }
    return answered.length > 0
}

//export const evaluateCondition = (condition, questionResponse) => {
//  const segments = condition.split(/\s+(and|or)\s+/i);
//  let finalResult = true;
//  let currentOperator = 'or'; 
//
//  for (let i = 0; i < segments.length; i++) {
//    const segment = segments[i].trim();
//    const regex = /Questionnaire\.item\.where\(id='(\w+)'\)\.answer\.value\s*(contains|>|<|=|!=)\s*'(.*)'/i;
//    const match = segment.match(regex);
//    let segmentResult = false; 
//
//    if (match) {
//      const id = match[1];
//      const operator = match[2];
//      const value = match[3];
//
//     const response = questionResponse.find(item => item.answerId === id);
//
//      if (response) {
//        const answerType = response?.answerType;
//        const answers = response?.answer || [];
//
//        if (answerType === 'checkbox' || answerType === 'radio') {
//          const selectedOptions = answers.filter(option => option.answer === true);
//          switch (operator) {
//            case 'contains':
//              segmentResult = selectedOptions.some(item => item.option?.includes(value));
//              break;
//            case '=':
//              segmentResult = selectedOptions.some(item => item.option === value);
//              break;
//            case '!=':
//              segmentResult = !selectedOptions.some(item => item.option === value);
//              break;
//           default:
//              segmentResult = false;
//              break;
//          }
//        } else {
//          const answerValue = answers[0]?.answer;
//          switch (operator) {
//            case 'contains':
//              segmentResult = answerValue?.includes(value);
//              break;
//            case '>':
//              segmentResult = answerValue && parseFloat(answerValue) > parseFloat(value);
//              break;
//            case '<':
//              segmentResult = answerValue && parseFloat(answerValue) < parseFloat(value);
//              break;
//            case '=':
//              segmentResult = answerValue === value;
//              break;
//            case '!=':
//              segmentResult = answerValue !== value;
//              break;
//            default:
//              segmentResult = false;
//              break;
//          }
//        }
//      }
//    } else {
//      console.warn(`Invalid condition segment: ${segment}`);
//    }
//
//    if (i > 0) {
//      if (currentOperator === 'and') {
//        finalResult = finalResult && segmentResult;
//      } else if (currentOperator === 'or') {
//        finalResult = finalResult || segmentResult;
//      }
//    } else {
//      finalResult = segmentResult; 
//    }
//
//    if (i < segments.length - 1) {
//      const nextOperatorMatch = segments[i + 1].match(/\s*(and|or)\s*/i);
//      if (nextOperatorMatch) {
//        currentOperator = nextOperatorMatch[1].toLowerCase();
//        i++;
//      }
//   }
//  }
//
//  return finalResult;
//};

{/*}
// Evaluate one atomic condition segment, same as your existing code but simplified here
function evaluateAtomicCondition(segment, questionResponse) {
  const regex = /Questionnaire\.item\.where\(id='(\w+)'\)\.answer\.value\s*(contains|>|<|=|!=)\s*'(.*)'/i;
  const match = segment.match(regex);
  if (!match) return false;

  const id = match[1];
  const operator = match[2];
  const value = match[3];

  const response = questionResponse.find((item) => item.answerId === id);
  if (!response) return false;

  const answerType = response.answerType;
  const answers = response.answer || [];

  if (answerType === "checkbox" || answerType === "radio") {
    const selectedOptions = answers.filter((option) => option.answer === true);
    switch (operator) {
      case "contains":
        return selectedOptions.some((item) => item.option?.includes(value));
      case "=":
        return selectedOptions.some((item) => item.option === value);
      case "!=":
        return !selectedOptions.some((item) => item.option === value);
      default:
        return false;
    }
  } else {
    const answerValue = answers[0]?.answer;
    switch (operator) {
      case "contains":
        return answerValue?.includes(value);
      case ">":
        return answerValue && parseFloat(answerValue) > parseFloat(value);
      case "<":
        return answerValue && parseFloat(answerValue) < parseFloat(value);
      case "=":
        return answerValue === value;
      case "!=":
        return answerValue !== value;
      default:
        return false;
    }
  }
}

*/}

// Parse tokens into AST respecting parentheses and operator precedence
function parseTokens(tokens) {
  const parseExpression = (start = 0) => {
    let operands = [];
    let operators = [];
    let i = start;

    const applyOperator = () => {
      const right = operands.pop();
      const left = operands.pop();
      const op = operators.pop();
      operands.push({ type: "operator", operator: op, left, right });
    };

    while (i < tokens.length) {
      const token = tokens[i];
      if (token === "(") {
        const [expr, nextIndex] = parseExpression(i + 1);
        operands.push(expr);
        i = nextIndex;
      } else if (token === ")") {
        break;
      } else if (token === "and" || token === "or") {
        // Apply previous operator if precedence is equal or higher
        while (
          operators.length &&
          (operators[operators.length - 1] === "and" ||
            operators[operators.length - 1] === "or")
        ) {
          applyOperator();
        }
        operators.push(token);
      } else {
        operands.push({ type: "condition", value: token });
      }
      i++;
    }

    while (operators.length) applyOperator();

    return [operands[0], i];
  };

  const [ast, _] = parseExpression(0);
  return ast;
}

// Evaluate the AST recursively
function evaluateAST(node, questionResponse) {
  if (node.type === "condition") {
    return evaluateAtomicCondition(node.value, questionResponse);
  }
  if (node.type === "operator") {
    const leftVal = evaluateAST(node.left, questionResponse);
    const rightVal = evaluateAST(node.right, questionResponse);
    if (node.operator === "and") {
      return leftVal && rightVal;
    }
    if (node.operator === "or") {
      return leftVal || rightVal;
    }
  }
  return false;
}



// Main function
export const evaluateCondition = (condition, questionResponse) => {
  const tokens = tokenize(condition);
  const ast = parseTokens(tokens);
  return evaluateAST(ast, questionResponse);
};


// Helper: strip html tags from free-text answers
function stripHTML(html) {
  if (!html) return "";
  // simple tag stripper - ok for small HTML fragments like <p>hello</p>
  return html.replace(/<[^>]*>/g, "").trim();
}

// Evaluate one atomic condition segment
function evaluateAtomicCondition(segment, questionResponse) {
  if (!segment || typeof segment !== "string") return false;
  segment = segment.trim();

  // Handle not(...) wrapper
  let negated = false;
  if (/^not\s*\(/i.test(segment)) {
    // find matching trailing ')', assume well-formed
    const inner = segment.replace(/^not\s*\(\s*([\s\S]*)\s*\)\s*$/i, "$1");
    return !evaluateAtomicCondition(inner, questionResponse);
  }

  // Two main patterns we expect:
  // 1) Method-style contains: Questionnaire.item.where(id='ID').answer.value.contains('VAL')
  // 2) Operator-style:    Questionnaire.item.where(id='ID').answer.value = 'VAL' (or !=, >, <, >=, <=)

  // Try method-style contains (and similar) first
  const methodContainsRegex = /Questionnaire\.item\.where\(\s*id\s*=\s*'([^']+)'\s*\)\.answer\.value(?:\.|\s*)contains\s*\(\s*'([^']*)'\s*\)/i;
  let m = segment.match(methodContainsRegex);
  if (m) {
    const id = m[1];
    const value = m[2];
    const response = questionResponse.find((r) => r.questionId === id);
    if (!response) return false;

    const answers = response.answer || [];
    if (response.answerType === "checkbox" || response.answerType === "radio") {
      const selected = answers.filter((a) => a.answer === true);
      return selected.some((s) => (s.option || "").toLowerCase().includes(value.toLowerCase()));
    } else {
      const raw = answers[0]?.answer;
      const plain = stripHTML(raw).toLowerCase();
      return plain.includes(value.toLowerCase());
    }
  }

  // Try operator-style ( =, !=, >, <, >=, <= )
  const opRegex = /Questionnaire\.item\.where\(\s*id\s*=\s*'([^']+)'\s*\)\.answer\.value\s*(<=|>=|!=|=|<|>)\s*'([^']*)'/i;
  m = segment.match(opRegex);
  if (m) {
    const id = m[1];
    const operator = m[2];
    const value = m[3];

    const response = questionResponse.find((r) => r.questionId === id);
    if (!response) return false;

    const answers = response.answer || [];

    if (response.answerType === "checkbox" || response.answerType === "radio") {
      // For selection lists we compare against the selected option text
      const selected = answers.filter((a) => a.answer === true);
      switch (operator) {
        case "=":
          return selected.some((s) => (s.option || "") === value);
        case "!=":
          return !selected.some((s) => (s.option || "") === value);
        default:
          return false; // >, < not sensible for selection labels
      }
    } else {
      // freeText or numeric-like
      const raw = answers[0]?.answer;
      const plain = stripHTML(raw);

      // numeric compare when both parse as numbers
      const numPlain = parseFloat(plain);
      const numValue = parseFloat(value);
      const bothNumbers = !isNaN(numPlain) && !isNaN(numValue);

      switch (operator) {
        case "=":
          return plain.toLowerCase() === value.toLowerCase();
        case "!=":
          return plain.toLowerCase() !== value.toLowerCase();
        case ">":
          return bothNumbers ? numPlain > numValue : false;
        case "<":
          return bothNumbers ? numPlain < numValue : false;
        case ">=":
          return bothNumbers ? numPlain >= numValue : false;
        case "<=":
          return bothNumbers ? numPlain <= numValue : false;
        default:
          return false;
      }
    }
  }

  // Fallback: attempt to match pattern using "contains" with dot syntax (e.g., ".contains('x')")
  // (already handled above) — if nothing matched, log and return false
  console.warn("evaluateAtomicCondition: unrecognized segment:", segment);
  return false;
}

// Tokenize expression into array of tokens (conditions, operators, parens),
// but don't split parentheses that are part of function/method calls (e.g. where(...), contains(...))
function tokenize(expr) {
  if (!expr || typeof expr !== "string") return [];
  const tokens = [];
  let buffer = "";
  let funcDepth = 0; // depth of parentheses that belong to function/method calls (inside a condition)

  const pushBuffer = () => {
    if (buffer.trim()) {
      tokens.push(buffer.trim());
      buffer = "";
    }
  };

  for (let i = 0; i < expr.length; i++) {
    const char = expr[i];

    // Detect logical 'and' / 'or' only when not inside function-method parentheses
    if (funcDepth === 0) {
      const ahead3 = expr.slice(i, i + 3).toLowerCase();
      const ahead2 = expr.slice(i, i + 2).toLowerCase();
      const prevChar = expr[i - 1] || " ";
      const nextAfterAnd = expr[i + 3] || " ";
      const nextAfterOr = expr[i + 2] || " ";

      // require boundary (prev is whitespace or '(' or start, next is whitespace or '(' or end)
      const prevIsBoundary = /[\s(]/.test(prevChar);
      const nextIsBoundaryAnd = /[\s)]/.test(nextAfterAnd) || i + 3 >= expr.length;
      const nextIsBoundaryOr = /[\s)]/.test(nextAfterOr) || i + 2 >= expr.length;

      if (ahead3 === "and" && prevIsBoundary && nextIsBoundaryAnd) {
        pushBuffer();
        tokens.push("and");
        i += 2; // skip 'nd'
        continue;
      }
      if (ahead2 === "or" && prevIsBoundary && nextIsBoundaryOr) {
        pushBuffer();
        tokens.push("or");
        i += 1; // skip 'r'
        continue;
      }
    }

    if (char === "(") {
      // If the char before '(' is non-whitespace (like "where(" or ".contains("),
      // treat this '(' as function/method parentheses (part of condition)
      const prev = expr[i - 1] || " ";
      if (!/\s/.test(prev) || funcDepth > 0) {
        funcDepth++;
        buffer += "(";
      } else {
        // outer grouping parenthesis
        pushBuffer();
        tokens.push("(");
      }
      continue;
    }

    if (char === ")") {
      if (funcDepth > 0) {
        funcDepth--;
        buffer += ")";
      } else {
        pushBuffer();
        tokens.push(")");
      }
      continue;
    }

    // default: accumulate char
    buffer += char;
  }

  pushBuffer();
  // Trim tokens cleanly
  return tokens.map((t) => (typeof t === "string" ? t.trim() : t));
}

